import {createAction} from '@reduxjs/toolkit'
import {
  CloudAppResponseType,
  PolicyNamePayloadType,
  CloudAppPayloadType,
} from 'interfaces/Policy'

export const getCloudApp = createAction<PolicyNamePayloadType>('getCloudApp')
export const getCloudAppSuccess =
  createAction<CloudAppResponseType>('getCloudAppSuccess')
export const getCloudAppFailure = createAction<string>('getCloudAppFailure')

export const updateCloudApp =
  createAction<CloudAppPayloadType>('updateCloudApp')
export const updateCloudAppSuccess = createAction<string>(
  'updateCloudAppSuccess',
)
export const updateCloudAppFailure = createAction<string>(
  'updateCloudAppFailure',
)

export const getBasePolicyCloudApp = createAction('getBasePolicyCloudApp')
export const getBasePolicyCloudAppSuccess = createAction<CloudAppResponseType>(
  'getBasePolicyCloudAppSuccess',
)
export const getBasePolicyCloudAppFailure = createAction<string>(
  'getBasePolicyCloudAppFailure',
)

export const changeCloudApp =
  createAction<CloudAppResponseType>('changeCloudApp')
export const removeCloudAppSnapshot = createAction('removeCloudAppSnapshot')
